import { bedaConfig } from './jsx-adapter';
export function usePathname() { return bedaConfig().route || '/'; }
export function notFound(): never { throw new Error('BEDA route not found'); }
